import React, { useState } from 'react';
import './DeleteConfirmationModal.css';

const DeleteConfirmationModal = ({ review, onClose, onConfirm }) => {
  const [sendNotification, setSendNotification] = useState(false);

  const handleConfirm = () => {
    onConfirm(sendNotification);
  };

  return (
    <div className="delete-modal-overlay" onClick={onClose}>
      <div className="delete-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-content">
          <div className="warning-icon">⚠️</div>
          <h2 className="modal-title">Delete Review?</h2>
          <p className="modal-text">
            Are you sure you want to delete this review? This action cannot be undone.
          </p>
          
          <label className="checkbox-option">
            <input
              type="checkbox"
              checked={sendNotification}
              onChange={(e) => setSendNotification(e.target.checked)}
            />
            <span>Send notification to customer</span>
          </label>
        </div>

        <div className="modal-footer">
          <button className="footer-btn cancel-btn" onClick={onClose}>
            Cancel
          </button>
          <button className="footer-btn delete-btn" onClick={handleConfirm}>
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmationModal;

